import { type Comment } from '@/server/db/schema';

/**
 * Shared by the `useComments` hook and `reloadUserComments` in `useAppState`, which read the same
 * cache entry. Kept in its own module because `useComments` imports `useAppState`, so either
 * consumer owning the key would create a cycle.
 */
export const commentsKeys = {
	all: ['comments'] as const,
	byLinkedUserId: (linkedUserId: number) => ['comments', 'linkedUserId', linkedUserId] as const,
};

export async function fetchComments(
	workspaceSlug: string,
	agentSlug: string,
	linkedUserId: number
): Promise<Comment[]> {
	const response = await fetch(`/api/${workspaceSlug}/${agentSlug}/users/${linkedUserId}/comments`);
	if (!response.ok) {
		throw new Error('Failed to fetch comments');
	}
	const { comments } = await response.json();
	// JSON serialization turns timestamps into strings; formatDate requires real Date instances.
	return comments.map((c: Comment) => ({
		...c,
		createdAt: c.createdAt ? new Date(c.createdAt) : c.createdAt,
		updatedAt: c.updatedAt ? new Date(c.updatedAt) : c.updatedAt,
	}));
}
